import { render, staticRenderFns } from "./QType1Answer.vue?vue&type=template&id=27dfd00c&scoped=true&"
import script from "./QType1Answer.vue?vue&type=script&lang=js&"
export * from "./QType1Answer.vue?vue&type=script&lang=js&"
import style0 from "./QType1Answer.vue?vue&type=style&index=0&id=27dfd00c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dfd00c",
  null
  
)

export default component.exports